import { debounce } from "./helpers/debounce";
import { superToggle } from "./helpers/super-toggle";

window.addEventListener('load', event => {
    // Desktop nav
    let desktopNavDropdownContent = document.querySelectorAll('.desktop-nav-dropdown-content');

    // Keeps land dropdown nav hidden for 500ms on page load to mask transitions
    for (let navDropdown of desktopNavDropdownContent) {
        setTimeout(function() {
            navDropdown.classList.remove('hidden');
        }, 500);
    }
});

window.addEventListener('load', () => {

    let headerNav = document.getElementById('siteheader');
    if (!headerNav.classList.contains('hidden-nav')) {
        let offCanvasMenuMobile = document.getElementById('offCanvasMenuMobile');
        let menuToggleMobile = document.getElementById('menuToggleMobile');
        let menuBackdrop = document.getElementById('menuBackdrop');
        let scrollLimit = 500;
        let navOpenScrollPosY = window.scrollY;

        let hamburgerTop1 = menuToggleMobile.querySelector('.hamburger-top-1');
        let hamburgerTop2 = menuToggleMobile.querySelector('.hamburger-top-2');
        let hamburgerMid = menuToggleMobile.querySelector('.hamburger-mid');
        let hamburgerBot = menuToggleMobile.querySelector('.hamburger-bot');

        if (offCanvasMenuMobile && menuToggleMobile) {
            // measures to stop menu appearing on page load
            offCanvasMenuMobile.removeAttribute('style');

            menuToggleMobile.addEventListener('click', () => {
                offCanvasMenuMobile.classList.toggle('-translate-y-full');
                if (hamburgerTop1 && hamburgerTop2 && hamburgerMid && hamburgerBot ){
                    superToggle(hamburgerTop1, ['!top-1/2', 'rotate-45']);
                    superToggle(hamburgerTop2, ['!top-1/2', '-rotate-45']);
                    superToggle(hamburgerMid, ['opacity-0', '!w-0']);
                    superToggle(hamburgerBot, ['opacity-0', '!w-0', '!-translate-y-2']);
                }
                navOpenScrollPosY = window.scrollY;
                menuBackdrop.classList.toggle('opacity-0');
                scrollLimit = (offCanvasMenuMobile.offsetHeight / 3) * 2;
                startListening();
            });
        }

        function closeMobileNav() {
            if (!offCanvasMenuMobile.classList.contains('-translate-y-full')) {
                offCanvasMenuMobile.classList.add('-translate-y-full');
                if (hamburgerTop1 && hamburgerTop2 && hamburgerMid && hamburgerBot ) {
                    hamburgerTop1.classList.remove('!top-1/2','rotate-45');
                    hamburgerTop2.classList.remove('!top-1/2','-rotate-45');
                    hamburgerMid.classList.remove('opacity-0','!w-0');
                    hamburgerBot.classList.remove('opacity-0','!w-0','!-translate-y-2');
                }
            }
            if (!menuBackdrop.classList.contains('opacity-0')) {
                menuBackdrop.classList.add('opacity-0');
            }
        }

        // closes open menus and resets nav to default state
        function closeAllNavs() {
            closeMobileNav();
        }

        function startListening() {
            window.addEventListener('click', clickListener);
            window.addEventListener('resize', resizeListener);
            window.addEventListener('scroll', scrollListener);
        }

        function stopListening() {
            window.addEventListener('click', clickListener);
            window.removeEventListener('resize', resizeListener);
            window.removeEventListener('scroll', scrollListener);
        }

        // Debounce for resize listener to close open menus on page resize
        const closeNavResizeDebouncer = debounce(() => {
            let windowSize = window.innerWidth;
            const checkWidth = setTimeout(() => {
                if (windowSize !== window.innerWidth) {
                    closeAllNavs();
                    stopListening();
                }
                clearTimeout(checkWidth);
            }, 50);
        });

        // Debounce for click listener to close open menus if click is not inside menu
        const closeNavClickDebouncer = debounce((event) => {
            if (!document.getElementById('siteheader').contains(event.target)) {
                closeAllNavs();
                stopListening();
            }
        });

        // Debounce for scroll listener to close open menus if scroll 200px or more below top of page
        const closeNavScrollDebouncer = debounce(() => {
            if (window.scrollY >= (scrollLimit + navOpenScrollPosY) || window.scrollY <= (navOpenScrollPosY - scrollLimit) && (!menuBackdrop.classList.contains('opacity-0'))) {
                closeAllNavs();
                stopListening();
            }
        });

        const clickListener = () => {
            closeNavClickDebouncer(event);
        };

        const resizeListener = () => {
            closeNavResizeDebouncer();
        };

        const scrollListener = () => {
            closeNavScrollDebouncer();
        };
    }
});
